// extracted by mini-css-extract-plugin
export default {"container":"userSettings_container__cTxvU","linksWrapper":"userSettings_linksWrapper__jI1kX","linkWrapper":"userSettings_linkWrapper__lWYw+"};